<template>
    <div class="msg-block" :class="['msg-block--' + type]">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        type: {type: String, default: 'info'}
    }
}
</script>
